import TableRows from '../TableRows';
import React from 'react';
import { TableViewProps } from './types';

const TableView: React.FunctionComponent<TableViewProps> = (props) => {
  const { render, ...otherProps } = props;
  if (render) {
    return render(otherProps);
  }
  return <TableRows {...otherProps} />;
};
export default React.memo(TableView);
